<div class="counter-container">
  <button class="counter-inc" (click)="decrement()" [disabled]="count <= min"> - </button>
  <input type="number" [min]="min" [max]="max" [ngClass]="count === 0 ? 'no-selection' : ''"
         [ngModel]="count" (ngModelChange)="updateValue($event)" #input>
  <!-- <div>{{reachedLimitOfAvailablity}}</div> -->
  <button class="counter-inc" (click)="increment()" [disabled]="(max !== undefined && count >= max) || reachedLimitOfAvailability || reachedMaximumPaxAndIsBlocking"> + </button>
</div>
